(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function businessDate(start, days) {
    const date = new Date(start);
    while (days > 0) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) days--; }
    return date;
  }
  function init(root = document) {
    root.querySelectorAll('[data-nd-delivery]').forEach(node => {
      const today = new Date();
      const format = date => date.toLocaleDateString('fr-FR', {weekday:'long',day:'numeric',month:'long'});
      node.textContent = `Commandé aujourd’hui, livré entre le ${format(businessDate(today, 5))} et le ${format(businessDate(today, 10))}.`;
    });
    root.querySelectorAll('[data-nd-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const gallery = product.querySelector('.nd-gallery');
      const figures = [...product.querySelectorAll('[data-media-id]')];
      const thumbs = [...product.querySelectorAll('[data-nd-thumb]')];
      const setCurrent = id => thumbs.forEach(a => a.setAttribute('aria-current', String(a.dataset.ndThumb === id)));
      const show = id => {
        const index = figures.findIndex(el => el.dataset.mediaId === id);
        if (index < 0) return;
        gallery.scrollTo({left:index * gallery.clientWidth,behavior:reduced()?'instant':'smooth'});
        setCurrent(id);
      };
      thumbs.forEach(a => a.addEventListener('click', e => { e.preventDefault(); show(a.dataset.ndThumb); }));
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
          if (figures[index]) setCurrent(figures[index].dataset.mediaId);
        });
      }, {passive:true});
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth) + (event.key === 'ArrowRight'?1:-1);
        if (figures[index]) show(figures[index].dataset.mediaId);
      });
      const button = product.querySelector('[data-nd-add]');
      const sticky = product.querySelector('[data-nd-sticky]');
      const stickyButton = product.querySelector('[data-nd-sticky-add]');
      const update = radio => {
        const available = radio.dataset.available === 'true';
        [button,stickyButton].forEach(b => { b.disabled = !available; b.textContent = available?'Ajouter au panier':'Indisponible'; });
        product.querySelector('[data-nd-price]').textContent = radio.dataset.price;
        product.querySelector('[data-nd-sticky-price]').textContent = radio.dataset.price;
        const inst = product.querySelector('[data-nd-installment]');
        if (inst && radio.dataset.priceCents) inst.textContent = (Math.ceil(Number(radio.dataset.priceCents) / 3) / 100).toLocaleString('fr-FR', {style:'currency', currency:'EUR'});
        product.querySelector('[data-nd-color]').textContent = radio.dataset.color;
        product.querySelector('[data-nd-sticky-color]').textContent = radio.dataset.color;
        
        const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url);
        if (radio.dataset.media) show(radio.dataset.media);
      };
      product.querySelectorAll('input[name="id"]').forEach(radio => radio.addEventListener('change', () => update(radio)));
      const selected = product.querySelector('input[name="id"]:checked');
      if (selected) update(selected);
      // Visible whenever the main purchase button is off screen (below on arrival, or above after scrolling).
      // Scroll-based so that jumps (anchors, restored scroll) that skip the button are handled.
      let stickyFrame;
      const syncSticky = () => { stickyFrame = null; const r = button.getBoundingClientRect(); sticky.hidden = r.bottom > 0 && r.top < innerHeight; };
      const queueSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
      addEventListener('scroll', queueSticky, {passive:true});
      addEventListener('resize', queueSticky);
      syncSticky();
      const dialog = product.querySelector('.nd-zoom');
      let opener;
      product.querySelectorAll('[data-nd-zoom]').forEach(trigger => trigger.addEventListener('click', () => {
        opener = trigger;
        const source = trigger.querySelector('img'), image = dialog.querySelector('img');
        image.src = source.src; image.alt = source.alt;
        dialog.showModal();
      }));
      const close = () => dialog.close();
      dialog.querySelector('[data-nd-close]').addEventListener('click', close);
      dialog.addEventListener('click', e => {if(e.target === dialog) close();});
      dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
    });
    if ('IntersectionObserver' in window) {
      document.documentElement.classList.add('nd-js');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('nd-visible'); observer.unobserve(entry.target); }
      }), {threshold:.12,rootMargin:'0px 0px -6% 0px'});
      root.querySelectorAll('.nd-reveal').forEach(el => observer.observe(el));
    }
    root.querySelectorAll('.nd-positions').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const figures = [...section.querySelectorAll('[data-nd-pos]')];
      const buttons = [...section.querySelectorAll('[data-nd-pos-btn]')];
      let current = 0, timer;
      const select = index => {
        current = index;
        figures.forEach((f, i) => f.classList.toggle('is-active', i === index));
        buttons.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
      };
      buttons.forEach((b, i) => b.addEventListener('click', () => { clearInterval(timer); select(i); }));
      if (!reduced() && figures.length > 1) timer = setInterval(() => select((current + 1) % figures.length), 3800);
    });
    const layers = [...root.querySelectorAll('[data-nd-parallax]')];
    if (layers.length && !reduced()) {
      let ticking = false;
      const move = () => {
        ticking = false;
        const vh = innerHeight;
        layers.forEach(layer => {
          const box = layer.parentElement.getBoundingClientRect();
          if (box.bottom < 0 || box.top > vh) return;
          const offset = (box.top + box.height / 2 - vh / 2) * -0.12;
          layer.style.transform = `translate3d(0,${offset.toFixed(1)}px,0)`;
        });
      };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(move); } }, {passive:true});
      move();
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
